import { addTrack } from "./utilidades/trackEventos";
import { obterQueryString } from "./utilidades/obterQueryString";
import { cortarTexto } from "./utilidades/cortarTexto";
import { isNullOrEmpty } from './utilidades/isNullOrEmpty';
import i18next from "i18next";
import { inicializarInternacionalizacao } from "./localizacao/vagas/vagas";
import { getUsuarioLogado } from "./utilidades/usuarioLogado";

import { listen as quicklinkListen } from "quicklink/dist/quicklink.mjs";
import { localBanner, banner } from './utilidades/banner'
import { AlertaVaga } from "./utilidades/alertaVaga";

// i18next.on('initialized', async () => {
inicializarInternacionalizacao();
const vagas = {
    props: {
        dadosFiltroDataPublicacao: {
            dados: [
                {
                    id: 'QualquerMomento',
                    nome: i18next.t('FiltroPublicacaoQualquerMomento')
                },
                {
                    id: 'Ultimas24horas',
                    nome: i18next.t('FiltroPublicacaoUltimasHoras')
                },
                {
                    id: 'UltimaSemana',
                    nome: i18next.t('FiltroPublicacaoUltimaSemana')
                },
                {
                    id: 'UltimoMes',
                    nome: i18next.t('FiltroPublicacaoUltimoMes')
                },
            ]
        },
        dadosFiltroOrdenacao: {
            dados: [
                {
                    id: 'DataAtualizacao',
                    nome: i18next.t('FiltroOrdenacaoDataAtualizacao')
                },
                {
                    id: 'Relevancia',
                    nome: i18next.t('FiltroOrdenacaoRelevancia'),
                    checked: true
                }
            ]
        },
        observerCarregarMaisVagas: new IntersectionObserver(entries => {
            const botao = entries[0];

            //Se olhar o botão, clica-o
            if (botao.isIntersecting && botao.target.dataset.status == "pronto") {
                botao.target.click();
            }
        },
            {
                threshold: 1
            }),
        paginaAtual: obterQueryString()['pagina'] || 1,
        queryUrlAmigavel: {
            query: document.getElementById('TermoBuscaVaga')?.value,
            localidade: document.getElementById('LocalidadeBuscaVaga')?.value,
        },
        filtrosSelecionados: [],
        containerFiltroNivelExperiencia: document.querySelector('.filtro-nivel-experiencia'),
        containerFiltroNivelExperienciaOffcanvas: document.querySelector('.filtro-nivel-experiencia-offcanvas'),
        containerFiltroCidadesOffcanvas: document.querySelector('.filtro-cidades-offcanvas'),
        containerFiltroEstadosOffcanvas: document.querySelector('.filtro-estados-offcanvas'),
        containerFiltroRegimeContratacao: document.querySelector('.filtro-regime-contratacao'),
        containerFiltroRegimeContratacaoOffcanvas: document.querySelector('.filtro-regime-contratacao-offcanvas'),
        containerFiltroTipoSelecaoOffcanvas: document.querySelector('.filtro-tipo-selecao-offcanvas'),
        containerFiltroTipoSelecao: document.querySelector('.filtro-tipo-selecao'),
        containerFiltroPcdOffcanvas: document.querySelector('.filtro-pcd-offcanvas'),
        containerFiltroPcd: document.querySelector('.filtro-pcd'),
        containerFiltroTipoRecrutamentoOffcanvas: document.querySelector('.filtro-tipo-recrutamento-offcanvas'),
        containerFiltroTipoRecrutamento: document.querySelector('.filtro-tipo-recrutamento'),
        containerFiltroPaisOffcanvas: document.querySelector('.filtro-paises-offcanvas'),
        containerFiltroDataPublicacaoOffcanvas: document.querySelector('.filtro-data-publicacao-offcanvas'),
        containerFiltroDataPublicacao: document.querySelector('.filtro-data-publicacao'),
        containerFiltroOrdenacaoOffcanvas: document.querySelector('.filtro-ordenacao-offcanvas'),
        containerFiltroModalidadeTrabalhoOffcanvas: document.querySelector('.filtro-remoto-offcanvas'),
        containerFiltroModalidadeTrabalho: document.querySelector('.filtro-remoto'),
        containerFiltroEmpresaUnidadeOffcanvas: document.querySelector('.filtro-empresa-unidade-offcanvas'),
        containerFiltroEmpresaUnidade: document.querySelector('.filtro-empresa-unidade'),
        falsoContainerFiltroCamposDinamicos: document.querySelector('#container-falso-filtros-campos-dinamicos'),
        falsoContainerFiltroCamposDinamicosOffcanvas: document.querySelector('#container-falso-filtros-campos-dinamicos-offcanvas'),
        hotsiteEmployerPage: document.getElementById('hotsite-employer-page')

    },
    removerCardsCarregamento(container) {
        container.querySelectorAll('.card-loading').forEach(el => el.remove());
    },
    templates: {
        textoIndicadorPagina(pagina, totalPaginas) {
            return `<p class="my-4 mx-3 mx-md-0">${i18next.t('TemplateTextoIndicadorPagina', { pagina: pagina, paginasRestantes: totalPaginas - pagina })}</p>`;
        },
        alertaNenhumFiltroEncontrado() {
            return this.alertaBase(i18next.t('TemplateAlertaNenhumFiltroEncontrado'), 'info', 'flex-fill');
        },
        alertaNenhumaVaga() {
            const usuario = getUsuarioLogado();
            return `
            <div role="alert">
                <div class="w-100 gap-2 flex-row justify-content-center align-items-center h-100 text-center">
                    <p class="h3">${i18next.t('TemplateAlertaNenhumaVagaTituloFiltro')}</p>
                    <p class="d-block">${i18next.t('TemplateAlertaNenhumaVagaSubtituloFiltro')}</p>
                </div>
                <div class="d-block d-sm-flex justify-content-center gap-2 text-center">
                    <button type="button" class="btn btn-outline-primary btn-eliminar-filtros col-11 col-sm-auto mb-3 mb-sm-0" id="limparFiltros">${i18next.t('TemplateAlertaNenhumaVagaLimparFiltros')}</button>
                    ${usuario && !usuario.logado ?
                    `<a href="/${CULTURE_EMPREGARE}/cadastrar-curriculo" class="btn btn-primary btn-block col-11 col-sm-auto">${i18next.t('TemplateAlertaNenhumaVagaCadastrarCurriculo')}</a>` : ''}
                </div>
            </div>`;
        },
        alertaBase(texto, tipo = 'warning', classesExtras = '') {
            return `
            <div class="alert alert-${tipo} ${classesExtras}" role="alert">
                <div class="d-flex w-100 gap-2 flex-row justify-content-center align-items-center h-100">
                    <i class="bi bi-info-circle-fill"></i>
                    <span>${texto}</span>
                </div>
            </div>`;
        },
        anuncio() {
            return `
            <div class="mb-3 anuncio-container" style="width:100%">
                <p class="w-100 text-uppercase text-center mb-3 text-muted"><small>${i18next.t('TemplateAnuncio')}</small></p>
                <ins class="adsbygoogle"
                style="display:block"
                data-ad-format="fluid"
                data-ad-layout-key="-h7-y+8-4t+hf"
                data-ad-client="ca-pub-6762183698372341"
                data-ad-slot="6223184802"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script>
            </div>
        `;
            //    return `
            //    <div class="mb-3" style="width:100%">
            //        <p class="w-100 text-uppercase text-center mb-3 text-muted"><small>${i18next.t('TemplateAnuncio')}</small></p>
            //        <ins class="adsbygoogle"
            //style="display:block;width:100%"
            //data-ad-client="ca-pub-6762183698372341"
            //data-ad-slot="7122409250"
            //data-ad-format="auto"
            //data-full-width-responsive="true"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script>
            //    </div>
            //`;
        },
        skeletonLoadingCardVaga(amount) {
            let html = '';
            for (let i = 0; i < amount; ++i) {
                html += `
                <div class="card shadow border-0 mb-3 card-loading">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-2 col-lg-1">
                                <div class="rounded card-loading-image"></div>
                            </div>
                            <div class="col-10 col-lg-11">
                                <div class="d-flex gap-2 justify-content-start justify-content-md-between">
                                    <div class="card-loading-bar" style="width: 50%"></div>
                                    <div class="card-loading-bar" style="width: 50%"></div>
                                </div>
                                <div class="card-loading-bar"></div>
                                <div class="card-loading-bar" style="height: 6em"></div>
                                <div class="d-flex gap-5">
                                    <div class="card-loading-bar" style="width: 5em"></div>
                                    <div class="card-loading-bar" style="width: 5em"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                `;
            }
            return html;
        },
        skeletonLoadingCardVagaEmployerPage(amount) {
            let html = '';
            for (let i = 0; i < amount; ++i) {
                html += `
                <div class="card shadow border-0 mb-3 card-loading">
                    <div class="card-body py-3">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="card-loading-bar" style="width: 80%"></div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="card-loading-bar" style="width: 50%"></div>
                            </div>
                        </div>
                    </div>
                </div>
                `;
            }
            return html;
        },
        skeletonLoadingFiltro(amount) {
            let html = '';
            for (let i = 0; i < amount; ++i) {
                html += `
                    <div class="row card-loading">
                        <div class="col-2">
                            <div class="rounded card-loading-image" style="width: 16px; height: 16px;"></div>
                        </div>
                        <div class="col-10">
                            <div class="card-loading-bar"></div>
                        </div>
                    </div>
                `;
            }
            return html;
        },
        cardVagaEmployerPage(data) {
            return `
            <a prefetch href="/${data.url}" class="text-decoration-none">
                <article class="card shadow-sm border-0 mb-2 card-vaga py-1">
                    <div class="card-body">
                        <div class="row gx-0 d-flex justify-content-center">
                            <div class="col-md-6 col-12">
                                <p class="fw-bold titulo-vaga text-truncate mb-0 ms-3">${data.titulo}</p>
                            </div>
                            <div class="col-md-6 col-12">
                                <p class="card-cidades mt-1 mb-0 text-muted ms-3">
                                    ${data.cidades.join('; ')}
                                </p>
                            </div>
                        </div>
                    </div>
                </article>
            </a>
            `;
        },
        cardVaga(data) {
            const pcdIconeHtml = data.pcd ? `<li title="${i18next.t('TemplateCardVagaDestinadaPCD')}" class="d-flex align-items-center badge bg-transparent px-0 ms-0 ms-md-4">
                                                <div class="row">
                                                    <div class="col">
                                                        <i class="bi bi-universal-access-circle fs-6 text-secondary"></i>
                                                    </div>
                                                </div>
                                            </li>` : '';
            const ocultarSeForTotalmenteRemoto = (data.cidades[0] === "Totalmente Remoto" || data.trabalhoRemoto === "NaoInformado") ? "d-none" : "";
            const nomeEmpresa = data.empresa == null ? "" : data.empresa;
            const salarioEmBranco = (data.salario == null || data.salario.length == 0);
            const salarioHtml = !salarioEmBranco ? `
                <li class="badge bg-span-card-vaga rounded-5 px-2">

                    <div class="row g-0">
                        <div class="col ps-2">
                            <i class="bi bi-cash fs-5"></i>
                        </div>
                        <div class="col gx-3 align-self-center">
                            <small class="fw-normal">${data.salario}</small>
                        </div>
                    </div>
                </li>
            ` : '';

            return `
            <a prefetch href="/${data.url}" class="text-decoration-none">
                <article class="card shadow-sm border-0 mb-3 card-vaga">
                    <div class="card-body">
                        <div class="row gx-0 d-flex justify-content-center">
                            <div class="col-2 col-lg-1">
                                <div class="img-responsiva rounded logo-aside-tamanho">
                                    <img loading=lazy class="" src="${data.logoThumb}" alt="${nomeEmpresa}" title="${nomeEmpresa}">
                                </div>
                            </div>
                            <div class="col-10 col-lg-11 ajuste-padding-col-vaga-info ps-md-0 ps-lg-3 ps-xl-0">
                                <div class="d-flex justify-content-between card-vaga-empresa-data" style="height: 2.2em">
                                    <p class="text-truncate card-vaga-empresa">${nomeEmpresa}</p>
                                    <p class="text-muted text-right me-2 me-md-0 card-vaga-data text-truncate"><small class="texto-data-card">${data.data}</small></p>
                                </div>
                                <p class="fw-bold fs-4 titulo-vaga text-truncate">${data.titulo}</p>
                                <p class="d-none d-lg-flex" style="margin-top: -0.8em">
                                    <small class="text-muted">
                                        ${data.chamada}
                                    </small>
                                </p>
                                <p class="card-cidades ${ocultarSeForTotalmenteRemoto}">
                                    <span class="badge bg-span-card-vaga rounded-5">
                                        <i class="bi bi-geo-alt fs-6"></i>
                                    </span>
                                    ${data.cidades.join('; ')}
                                </p>
                                
                                <ul class="d-none d-md-flex ps-0">
                                    
                                        <li class="badge bg-span-card-vaga rounded-5 px-2 me-4 ${(data.trabalhoRemoto === "NaoInformado" ? 'd-none' : '')}">
                                            <div class="row g-0">
                                                <div class="col ps-2">
                                                    <i class="bi bi-briefcase-fill fs-5"></i>
                                                </div>
                                                <div class="col gx-3 align-self-center">
                                                    <small class="fw-normal">${data.trabalhoRemotoTexto}</small>
                                                </div>
                                            </div>
                                        </li>                                 

                                    ${salarioHtml}

                                    ${pcdIconeHtml}

                                </ul>

                            </div>
                        </div>
                    </div>
                </article>
            </a>
            `;
        },
        radioFiltro(indice, inputName, data, paddingLateral = true) {
            const classePaddingLateral = paddingLateral ? 'ps-3' : '';
            const uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
            const inicialmenteChecked = data.checked ? 'checked' : '';
            let html = `
            <div class="col gy-2 ${classePaddingLateral}">
                    <div class="form-check">
                        <input class="form-check-input dropdown-check-filtra" type="radio" name="${inputName}" value="${data.id}" id="${inputName}_${indice}_${uniqueId}" ${inicialmenteChecked}>
                        <label class="form-check-label" for="${inputName}_${indice}_${uniqueId}">
                        ${data.nome}
                        </label>
                    </div>
                </div>
            `;
            return html;
        },
        checkboxFiltro(indice, inputName, data, paddingLateral = true, offcanvas = false) {
            const classePaddingLateral = paddingLateral ? 'ps-3' : '';
            const indicador = offcanvas ? '_offcanvas' : '';
            let html = `
            <div class="col gy-2 ${classePaddingLateral}">
                    <div class="form-check">
                        <input class="form-check-input dropdown-check-filtra" type="checkbox" name="${inputName}" value="${data.id}" id="${inputName}_${indice}${indicador}">
                        <label style="overflow-wrap: anywhere;" class="form-check-label" for="${inputName}_${indice}${indicador}">
                        ${data.nome}
                        </label>
                    </div>
                </div>
            `;
            return html;
        },
        switchFiltro(inputName, offcanvas, textoAuxiliar = '') {
            const indicador = offcanvas ? '_offcanvas' : '';
            const labelAuxiliar = textoAuxiliar.length > 0 ? `<label class="form-check-label ms-2 mt-2" for="${inputName}${indicador}">${textoAuxiliar}</label>` : '';
            return `
            <div class="form-switch">
                <input class="form-check-input filtro-switch" type="checkbox" role="switch" name="${inputName}" id="${inputName}${indicador}" value="true">
                ${labelAuxiliar}
            </div>
            `;
        }
    },
    async atualizarListaFiltrosSelecionados(novosFiltros, pushState = true) {
        for (let i = 0; i < novosFiltros.length; ++i) {
            const filtroAtual = { nome: novosFiltros[i].nome, valor: novosFiltros[i].valor };

            const filtroNaListaIndex = this.props.filtrosSelecionados.findIndex(x => x.nome == filtroAtual.nome);
            if (filtroNaListaIndex != -1) { //encontrou
                this.props.filtrosSelecionados[filtroNaListaIndex] = filtroAtual;
            } else if (filtroNaListaIndex == -1) { //nao encontrou na lista
                this.props.filtrosSelecionados.push(filtroAtual);
            }
        }
        if (pushState) {
            await this.eventoPushStateFiltros();
            this.atualizarTextoQuantidadeGlobalFiltrosSelecionados();
        }
    },
    atualizarTextoQuantidadeGlobalFiltrosSelecionados() {
        const textoQuantidadeFiltrosSelecionados = document.querySelector('.text-quantidade-filtros-selecionados');
        const urlParametros = obterQueryString().getAll;

        let verificouQuery = false;
        let verificouLocalidade = false;
        let quantidade = 0;

        for (const filtro in urlParametros) {
            urlParametros[filtro].forEach(valor => {
                if (valor.trim().length > 0) {
                    if (valor != 0)
                        ++quantidade;
                    if (filtro === 'query') {
                        verificouQuery = true;
                    }

                    if (filtro === 'localidade') {
                        verificouLocalidade = true;
                    }
                }
            });
        }

        //Em caso de ter querySEO
        if (!isNullOrEmpty(this.props.queryUrlAmigavel.query) && !verificouQuery) {
            ++quantidade;
        }

        if (!isNullOrEmpty(this.props.queryUrlAmigavel.localidade) && !verificouLocalidade) {
            ++quantidade;
        }

        textoQuantidadeFiltrosSelecionados.innerHTML = quantidade;

    },
    manipularDropdownFiltroSelecionado(nomeInput) {
        const quantidadeFiltroEspecificoSelecionado = this.props.filtrosSelecionados.filter(x => x.nome == nomeInput).length;
        const btnClasseSelecionado = 'btn-secondary';
        const dropdownsToggleFiltroEspecificadoSelecionado = document.querySelectorAll(`.dropdown-${nomeInput}`);
        
        dropdownsToggleFiltroEspecificadoSelecionado.forEach(dropdownToggleFiltroEspecificadoSelecionado => {
            if (dropdownToggleFiltroEspecificadoSelecionado) {
                if (quantidadeFiltroEspecificoSelecionado == 0) {
                    dropdownToggleFiltroEspecificadoSelecionado.classList.remove(btnClasseSelecionado);
                } else {
                    dropdownToggleFiltroEspecificadoSelecionado.classList.add(btnClasseSelecionado);
                }
    
                const elementoFiltroEspecificoQuantidade = dropdownToggleFiltroEspecificadoSelecionado.querySelector(`.quantidade-${nomeInput}-filtro`);
                if (elementoFiltroEspecificoQuantidade != undefined) {
                    elementoFiltroEspecificoQuantidade.innerHTML = quantidadeFiltroEspecificoSelecionado == 0 ? '' : `(${quantidadeFiltroEspecificoSelecionado})`;
                }
            }
        });
    },
    manipularFiltrosSelecionados(elemento) {
        const nomeInput = elemento.getAttribute('name');
        const valorSelecionado = elemento.value;

        const filtroAtual = { nome: nomeInput, valor: valorSelecionado };

        let filtroNaListaIndex = this.props.filtrosSelecionados.findIndex(x => x.nome == filtroAtual.nome && x.valor == filtroAtual.valor);

        //Essa condição serve para o caso dos inputs de cargo e localização
        if (elemento.type == 'text') {

            filtroNaListaIndex = this.props.filtrosSelecionados.findIndex(x => x.nome == filtroAtual.nome);

            //Se encontrar o termo, ele remove da lista e readiciona
            if (filtroNaListaIndex != -1) {
                this.props.filtrosSelecionados.splice(filtroNaListaIndex, 1);
            }

            this.props.filtrosSelecionados.push(filtroAtual);

            //Em caso de filtragem por cargo/localizacao do offcanvas gera historico
            if (filtroAtual.nome == 'query' || filtroAtual.nome == 'localidade') {
                (async () => {

                    const { vagasBuscasRecentesCargoAdicionar, vagasBuscasRecentesLocalizacaoAdicionar } = await import('./utilidades/eventoBuscarVagaRedirect');

                    if (filtroAtual.nome == 'query') {
                        vagasBuscasRecentesCargoAdicionar(filtroAtual.valor);
                    }
                    else if (filtroAtual.nome == 'localidade') {
                        vagasBuscasRecentesLocalizacaoAdicionar(filtroAtual.valor);
                    }

                })();
            }

        } else {
            //Serve para casos de checkbox e radio
            if (filtroNaListaIndex != -1 && !elemento.checked) { //encontrou e está desmarcado
                this.props.filtrosSelecionados.splice(filtroNaListaIndex, 1);
            } else if (filtroNaListaIndex == -1 && elemento.checked) { //nao encontrou na lista mas esta marcado
                this.props.filtrosSelecionados.push(filtroAtual);
            }
            else if ((filtroAtual.nome == 'selecaoCega' || filtroAtual.nome == 'pcd') && filtroNaListaIndex == -1 && !elemento.checked) {
                /*
                Caso seja um desses filtros, vai remover em caso de aplicar o filtro com ele desmarcado, nao vai setar false, vai remover da lista
                e não enviar pro backend
                */
               this.props.filtrosSelecionados = this.props.filtrosSelecionados.filter(x => x.nome != filtroAtual.nome);
            }
        }
    },
    async eventoPushStateFiltros() {
        //Transform a lista local de filtros selecionados em uma query string

        let queryString = ``;
        if (this.props.filtrosSelecionados.length == 0) {
            //Caso nao tenha mais valor na queryAmigavel e o pathname for sem ser o amigável, limpa textos, pois nao tem mais filtro
            if (!isNullOrEmpty(this.props.queryUrlAmigavel.query) && !location.pathname.includes('vagas-')) {
                this.props.queryUrlAmigavel.query = '';
            }
            if (!isNullOrEmpty(this.props.queryUrlAmigavel.localidade) && !location.pathname.includes('vagas-')) {
                this.props.queryUrlAmigavel.localidade = '';
            }
            window.history.pushState({}, '', `${location.pathname}?${queryString}`);
            await this.obterVagas(true, true);
            return;
        }
        for (let i = 0; i < this.props.filtrosSelecionados.length; ++i) {
            queryString += `&${this.props.filtrosSelecionados[i].nome}=${encodeURIComponent(this.props.filtrosSelecionados[i].valor)}`;
        }
        queryString = queryString.substring(1);

        const urlBase = `/${CULTURE_EMPREGARE}/vagas`;
        let urlComplemento = '';

        function _verificaLimpaQueryLocalidadeSEO(idElemento, nome) {
            const filtroTermo = vagas.props.filtrosSelecionados.find(x => x.nome == nome);
            //Se tiver um tempo e for diferente do termo SEO, precisa remover o termoSEO
            const queryTermo = nome === "query" ? vagas.props.queryUrlAmigavel.query.toLowerCase() : vagas.props.queryUrlAmigavel.localidade.toLowerCase();
            if (filtroTermo != null && filtroTermo.valor.toLowerCase() != queryTermo) {
                document.getElementById(idElemento).value = '';
            }
        }

        function _parametroQueryStringEstaDiferente(parametro) {
            const filtroTermo = vagas.props.filtrosSelecionados.find(x => x.nome == parametro);
            const queryTermo = parametro === "query" ? vagas.props.queryUrlAmigavel.query.toLowerCase() : vagas.props.queryUrlAmigavel.localidade.toLowerCase();
            if (filtroTermo != null && filtroTermo.valor.toLowerCase() != queryTermo) {
                return true;
            }
            return false;
        }

        function _removerParametroEspecificoQueryString(parametro) {
            const queryStringFiltrada = new URLSearchParams(queryString);
            queryStringFiltrada.delete(parametro);
            queryString = queryStringFiltrada.toString();
        }

        const queryEstaDiferente = _parametroQueryStringEstaDiferente('query');
        const localidadeEstaDiferente = _parametroQueryStringEstaDiferente('localidade');
        const prefixoQueryURLAmigavel = location.pathname.includes('vagas-de');
        const prefixoLocalidadeURLAmigavel = location.pathname.includes('-em-');

        if (!isNullOrEmpty(this.props.queryUrlAmigavel.query) && isNullOrEmpty(this.props.queryUrlAmigavel.localidade) && prefixoQueryURLAmigavel) {
            //vagas-de-{query}
            urlComplemento += `-de-${this.props.queryUrlAmigavel.query.replace(' ', '-')}`;
        }
        else if (isNullOrEmpty(this.props.queryUrlAmigavel.query) && !isNullOrEmpty(this.props.queryUrlAmigavel.localidade) && prefixoLocalidadeURLAmigavel) {
            //vagas-em-{localidade}
            urlComplemento += `-em-${this.props.queryUrlAmigavel.localidade.replace(' ', '-')}`;
        }
        else if (isNullOrEmpty(this.props.queryUrlAmigavel.query) && isNullOrEmpty(this.props.queryUrlAmigavel.localidade) && !prefixoQueryURLAmigavel && !prefixoLocalidadeURLAmigavel) {
            //vagas
            urlComplemento = '';
        }
        else {
            if (prefixoQueryURLAmigavel && prefixoLocalidadeURLAmigavel) {
                //vagas-de-{query}-em-{localidade}
                urlComplemento += `-de-${this.props.queryUrlAmigavel.query.replace(' ', '-')}-em-${this.props.queryUrlAmigavel.localidade.replace(' ', '-')}`;
            }
            else {
                const termoQuery = this.props.queryUrlAmigavel.query || this.props.queryUrlAmigavel.localidade;
                urlComplemento += prefixoQueryURLAmigavel ? `-de-${termoQuery.replace(' ', '-')}` : `-em-${termoQuery.replace(' ', '-')}`;
            }
        }

        if (queryEstaDiferente || localidadeEstaDiferente) {
            urlComplemento = '';
            if (queryEstaDiferente) {
                _verificaLimpaQueryLocalidadeSEO('TermoBuscaVaga', 'query');
            }
            if (localidadeEstaDiferente) {
                _verificaLimpaQueryLocalidadeSEO('LocalidadeBuscaVaga', 'localidade');
            }
        } else {
            if (!queryEstaDiferente && prefixoQueryURLAmigavel) {
                _removerParametroEspecificoQueryString('query');
            }
            if (!localidadeEstaDiferente && prefixoLocalidadeURLAmigavel) {
                _removerParametroEspecificoQueryString('localidade');
            }
        }

        let urlComCompletemento = urlBase + urlComplemento;
        //Isso evita em caso de 'vagas-em-df' trocar para 'vagas-em-brasília, df' devido a localidade
        if (!location.pathname.includes(urlComCompletemento)) {
            urlComCompletemento = location.pathname;
        }

        window.history.pushState({}, '', `${urlComCompletemento}?${queryString}`);
        await this.obterVagas(true, true);
    },
    async acaoEliminarFiltroEspecifico(nomeInput) {
        //Toda vez que aplicar/remover filtro, jogar o scroll para cima
        if(!vagas.props.hotsiteEmployerPage)
            window.scrollTo(0, 0);

        const aplicandoPeloOffcanvas = nomeInput == null;

        if (nomeInput != null) {
            const filtrosSelecionadosNovo = this.props.filtrosSelecionados.filter(x => x.nome !== nomeInput);
            this.props.filtrosSelecionados = filtrosSelecionadosNovo;
            this.manipularDropdownFiltroSelecionado(nomeInput);
        } else {
            this.props.filtrosSelecionados = [];
            document.querySelectorAll('.dropdown-toggle').forEach(el => {
                el.classList.remove('btn-secondary');
                if (el.querySelector('.quantidade-filtro') != undefined) {
                    el.querySelector('.quantidade-filtro').innerHTML = '';
                }
            });
        }

        await this.eventoPushStateFiltros();
    },
    async acaoAplicarFiltroEspecifico(nomeInput) {
        //Toda vez que aplicar/remover filtro, jogar o scroll para cima
        if(!vagas.props.hotsiteEmployerPage)
            window.scrollTo(0, 0);

        const aplicandoPeloOffcanvas = nomeInput == null;
        if (nomeInput != null) {
            document.querySelectorAll('input[name="' + nomeInput + '"]').forEach(el => {
                this.manipularFiltrosSelecionados(el);
                this.manipularDropdownFiltroSelecionado(nomeInput);
            });
        }
        else {
            document.querySelector('.todos-filtros-body').querySelectorAll('input').forEach(el => {
                nomeInput = el.getAttribute('name');
                this.manipularFiltrosSelecionados(el);
                this.manipularDropdownFiltroSelecionado(nomeInput);
            });
        }

        await this.eventoPushStateFiltros();
    },
    acaoPesquisaLocalContainerFiltro(inputName) {
        document.querySelector('input[name="search_' + inputName + '"]').addEventListener('input', e => {
            document.querySelectorAll('input[name="' + inputName + '"]').forEach(x => {
                if (!x.value.toLowerCase().includes(e.target.value.toLowerCase())) {
                    x.closest('.col').style.display = 'none';
                }
                else {
                    x.closest('.col').style.display = 'flex';
                }
            });
        });
    },
    mudarValorInputsCargoLocalizacao(valorInputCargo, valorInputLocalizacao) {
        
        document.querySelector('#filtro-cargo').value = valorInputCargo;
        document.querySelector('#filtro-localizacao').value = valorInputLocalizacao;
        
        document.querySelectorAll('.busca-vaga').forEach(el => {
            el.querySelector('input[name="cargo"]').value = valorInputCargo;
            el.querySelector('input[name="localizacao"]').value = valorInputLocalizacao;
        });

        const hotsite = document.querySelector('#layout-hotsite');

        if (hotsite) {
            const cargoInput = hotsite.querySelector('#cargo');
            const localizacaoInput = hotsite.querySelector('#localizacao-0');

            if(cargoInput)
                cargoInput.value = valorInputCargo;
            if(localizacaoInput)
                localizacaoInput.value = valorInputLocalizacao;

        }
    },
    mudarTermoBuscaVagaTexto(query, localidade) {
        if (isNullOrEmpty(query) && isNullOrEmpty(localidade)) {
            const termoBuscaVagaTexto =  document.getElementById('TermoBuscaVagaTexto');
            if(termoBuscaVagaTexto)
                termoBuscaVagaTexto.textContent = i18next.t('MudarTermoBuscaVagaTextoFiltrosVazios');
            return;
        }
        let textoCompleto = '';
        query = query?.replace(/-/g, " ").replace(/(^\w{1})|(\s+\w{1})/g, function (primeiraLetra) { return primeiraLetra.toUpperCase() });
        localidade = localidade?.replace(/-/g, " ").replace(/(^\w{1})|(\s+\w{1})/g, function (primeiraLetra) { return primeiraLetra.toUpperCase() });

        if (isNullOrEmpty(query) && !isNullOrEmpty(localidade)) {
            textoCompleto = i18next.t('MudarTermoBuscaVagaTextoComLocalidade', { localidade: localidade });

        }
        else if (isNullOrEmpty(localidade) && !isNullOrEmpty(query)) {
            textoCompleto = i18next.t('MudarTermoBuscaVagaTextoComFiltro', { filtro: query });
        }
        else {
            textoCompleto = i18next.t('MudarTermoBuscaVagaTextoComAmbosFiltros', { filtro: query, localidade: localidade });
        }

        const termoBuscaVagaTexto = document.getElementById('TermoBuscaVagaTexto');
        if (termoBuscaVagaTexto) 
            termoBuscaVagaTexto.textContent = textoCompleto;

        document.title = textoCompleto + ' | EMPREGARE.com';

    },
    resetarObserverCarregarMaisVagas() {
        this.props.observerCarregarMaisVagas.disconnect();
    },
    montarFiltros(data, mudarTermoBuscaVagaTexto) {

        if (mudarTermoBuscaVagaTexto) {

            if (obterQueryString()['query'] != null) {
                const termoBuscaVaga = document.getElementById('TermoBuscaVaga');

                if(termoBuscaVaga){
                    termoBuscaVaga.value = obterQueryString()['query'];
                    this.props.queryUrlAmigavel.query = termoBuscaVaga.value;
                    this.mudarTermoBuscaVagaTexto(this.props.queryUrlAmigavel.query, this.props.queryUrlAmigavel.localidade);
                }
            }
            if (obterQueryString()['localidade'] != null) {
                const localidadeBuscaVaga = document.getElementById('LocalidadeBuscaVaga');

                if(localidadeBuscaVaga){
                    localidadeBuscaVaga.value = obterQueryString()['localidade'];
                    this.props.queryUrlAmigavel.localidade =localidadeBuscaVaga.value;
                    this.mudarTermoBuscaVagaTexto(this.props.queryUrlAmigavel.query, this.props.queryUrlAmigavel.localidade);

                }
            }
        }

        this.mudarValorInputsCargoLocalizacao(this.props.queryUrlAmigavel.query, this.props.queryUrlAmigavel.localidade); //valorInputLocalizacao

        function _preencherHTMLFiltroNoContainer(nome, data, container, possuiOffcanvas, containerOffcanvas, paddingLateral = false, tipo = 'checkbox', textoAuxiliarSwitch = '') {
            let conteudo = '', conteudoOffcanvas = '';

            function _manipulaConteudoPeloTipo(i, filtro, offcanvas) {
                let retorno = '';
                switch (tipo) {
                    case 'checkbox':
                        retorno += vagas.templates.checkboxFiltro(i, nome, filtro, paddingLateral, offcanvas);
                        break;
                    case 'radio':
                        retorno += vagas.templates.radioFiltro(i, nome, filtro, paddingLateral);
                        break;
                    case 'switch':
                        retorno += vagas.templates.switchFiltro(nome, offcanvas, offcanvas ? '' : textoAuxiliarSwitch);
                        break;
                    default:
                        retorno += vagas.templates.checkboxFiltro(i, nome, filtro, paddingLateral, offcanvas);
                        break;
                }
                return retorno;
            }
            if (data != null && data.length > 0) {
                for (let i = 0; i < data.length; ++i) {
                    const filtro = data[i];
                    if (nome === "estado" && filtro.id.length == 0) { continue; }
                    if (possuiOffcanvas) {
                        conteudoOffcanvas += _manipulaConteudoPeloTipo(i, filtro, true);
                    }
                    conteudo += _manipulaConteudoPeloTipo(i, filtro, false);
                }
            } else if (data == null && tipo === 'switch') {
                if (possuiOffcanvas) {
                    conteudoOffcanvas += _manipulaConteudoPeloTipo(0, null, true);
                }
                conteudo += _manipulaConteudoPeloTipo(0, null, false);
            } else {
                conteudo = conteudoOffcanvas = vagas.templates.alertaNenhumFiltroEncontrado();
            }

            if (container != null) {
                container.innerHTML = conteudo;
            }
            if (containerOffcanvas != null && possuiOffcanvas) {
                containerOffcanvas.innerHTML = conteudoOffcanvas;
            }
        }

        const _criarCamposDinamicos = (campo) => {
            const parentNodeOffcanvas = this.props.falsoContainerFiltroCamposDinamicosOffcanvas.parentNode;
            const parentNode = this.props.falsoContainerFiltroCamposDinamicos.parentNode;
            if (document.getElementById(`campo-dinamico-${campo.id}-filtro`)) {
                _preencherHTMLFiltroNoContainer(`camposDinamicos-${campo.id}`, campo.conteudos, parentNode.querySelector(`#campo-dinamico-${campo.id}-filtro`), true, parentNodeOffcanvas.querySelector(`#campo-dinamico-${campo.id}-filtro-offcanvas`), false, 'checkbox', campo.nome);
                return;
            }

            let html = 
                `<div class="px-3 py-3 border border-start-0 border-end-0 border-bottom-0">
                    <p class="fw-bold">${campo.nome}</p>
                    <div class="row row-cols-2 gx-0 container-filtro filtro-campo-dinamico-${campo.id}-offcanvas" id="campo-dinamico-${campo.id}-filtro-offcanvas"></div>
                </div>`

            const containerFalsoOffcanvas = document.createElement('div')
            containerFalsoOffcanvas.innerHTML = html;
            parentNodeOffcanvas.insertBefore(containerFalsoOffcanvas, this.props.falsoContainerFiltroCamposDinamicosOffcanvas);
            
            html = 
            `
            <div class="dropdown dropdown-center me-3 d-none d-xxl-block">
                <button class="btn btn-default dropdown-toggle dropdown-camposDinamicos-${campo.id} border rounded-5 px-3" type="button" data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="dropdown-texto-interno">${campo.nome} <span class="quantidade-campo-dinamico-${campo.id}-filtro"></span></span> <i class="bi bi-chevron-down"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-container">
                    <div class="row gx-2 pt-2">
                        <div class="col-10">
                            <p class="ps-3 fw-bold">${campo.nome}</p>
                        </div>
                        <div class="col-2">
                            <button type="button" class="fechar-modal pb-0 btn-fechar-dropdown"><i class="bi bi-x-circle fs-6 text-right"></i></button>
                        </div>
                    </div>
                    <form action="" method="get">
                        <div class="row row-cols-1 gx-0 px-3 dropdown-menu-scroll filtro-campo-dinamico-${campo.id}" id="campo-dinamico-${campo.id}-filtro"></div>
                        <div class="py-3 border-top d-flex align-content-center justify-content-center w-100">
                            <button class="btn btn-link text-decoration-none text-primary bg-transparent me-2 btn-eliminar-campo-dinamico" data-filtro="camposDinamicos-${campo.id}">${i18next.t('BtnEliminarFiltro')}</button>
                            <button class="btn btn-primary btn-aplicar-campo-dinamico" data-filtro="camposDinamicos-${campo.id}">${i18next.t('BtnAplicarFiltro')}</button>
                        </div>
                    </form>
                </div>
            </div>
            `;
            
            const containerFalso = document.createElement('div')
            containerFalso.innerHTML = html;
            parentNode.insertBefore(containerFalso, this.props.falsoContainerFiltroCamposDinamicos.nextSibling);

            
            const botaoAplicar = containerFalso.querySelector('.btn-aplicar-campo-dinamico');
            botaoAplicar.onclick = async (e) => {
                await this.eventoClickBotaoFiltros(e, botaoAplicar, false);
            };

            const botaoEliminar = containerFalso.querySelector('.btn-eliminar-campo-dinamico')
            botaoEliminar.onclick = async (e) => {
                await this.eventoClickBotaoFiltros(e, botaoEliminar, true);

                document.querySelectorAll(`input[name="camposDinamicos-${campo.id}"]`).forEach(el => {
                    this.manipularFiltrosSelecionados(el);
                });
            };

            _preencherHTMLFiltroNoContainer(`camposDinamicos-${campo.id}`, campo.conteudos, parentNode.querySelector(`#campo-dinamico-${campo.id}-filtro`), true, parentNodeOffcanvas.querySelector(`#campo-dinamico-${campo.id}-filtro-offcanvas`), false, 'checkbox', campo.nome);
        }

        _preencherHTMLFiltroNoContainer('modalidade', data.remoto, this.props.containerFiltroModalidadeTrabalho, true, this.props.containerFiltroModalidadeTrabalhoOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('nivel', data.nivel, this.props.containerFiltroNivelExperiencia, true, this.props.containerFiltroNivelExperienciaOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('cidade', data.cidade, null, true, this.props.containerFiltroCidadesOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('empresaUnidade', data.empresaUnidade, this.props.containerFiltroEmpresaUnidade, true, this.props.containerFiltroEmpresaUnidadeOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('estado', data.uf, null, true, this.props.containerFiltroEstadosOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('pais', data.pais, null, true, this.props.containerFiltroPaisOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('regime', data.regime, this.props.containerFiltroRegimeContratacao, true, this.props.containerFiltroRegimeContratacaoOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('tipoRecrutamento', data.tipoRecrutamento, this.props.containerFiltroTipoRecrutamento, true, this.props.containerFiltroTipoRecrutamentoOffcanvas, false, 'checkbox');
        _preencherHTMLFiltroNoContainer('dataPublicacao', this.props.dadosFiltroDataPublicacao.dados, this.props.containerFiltroDataPublicacao, true, this.props.containerFiltroDataPublicacaoOffcanvas, false, 'radio');
        _preencherHTMLFiltroNoContainer('ordenacao', this.props.dadosFiltroOrdenacao.dados, null, true, this.props.containerFiltroOrdenacaoOffcanvas, false, 'radio');
        _preencherHTMLFiltroNoContainer('selecaoCega', null, this.props.containerFiltroTipoSelecao, true, this.props.containerFiltroTipoSelecaoOffcanvas, false, 'switch', i18next.t('LabelFiltroSelecaoCega'));
        _preencherHTMLFiltroNoContainer('pcd', null, this.props.containerFiltroPcd, true, this.props.containerFiltroPcdOffcanvas, false, 'switch', i18next.t('LabelFiltroPCD'));

        if (data.camposDinamicos) {
            for (const campoDinamico of data.camposDinamicos) {
                _criarCamposDinamicos(campoDinamico);
            }
        }

        document.querySelectorAll('.filtro-switch').forEach(el => el.addEventListener('change', (e) => {
            e.target.value = e.target.checked;
        }));
    },
    async obterVagas(limparHTML = false, acionadoPeloPopstate = false, carregarListaDeVagas = true) {

        this.resetarObserverCarregarMaisVagas();
        const itensPagina = vagas.props.hotsiteEmployerPage ? 4 : 10;

        if(vagas.props.hotsiteEmployerPage)
            carregarListaDeVagas = true;
        
        const filtrosPaginacao = `pagina=${this.props.paginaAtual}&itensPagina=${itensPagina}`;
        let todosFiltros = filtrosPaginacao + this.verificarURLFiltros();

        const boxQuantidadeTotalVagas = document.querySelectorAll('.box-quantidade-total-vagas');
        const quantidadeTotalVagas = document.querySelectorAll('.quantidade-total-vagas');

        if (carregarListaDeVagas && limparHTML) {
            boxQuantidadeTotalVagas.forEach(el => {
                el.style.display = 'none';
            });
        }

        const containerVagas = document.querySelector('.listagem-vagas');

        if (limparHTML) {
            containerVagas.innerHTML = '';
        }

        if (carregarListaDeVagas) {
            containerVagas.innerHTML += vagas.props.hotsiteEmployerPage ? this.templates.skeletonLoadingCardVagaEmployerPage(3): this.templates.skeletonLoadingCardVaga(3);
        }

        const boxCarregarMaisVagas = document.querySelector('.box-carregar-mais-vagas');
        const botaoCarregarMaisVagas = boxCarregarMaisVagas?.querySelector('.btn-carregar-mais-vagas');

        try {
            let hotSiteEmpresaID = '';
            let hotSiteUrl = '';

            if (document.getElementById('hotSiteEmpresaID')) {
                hotSiteEmpresaID = document.getElementById('hotSiteEmpresaID').value;
                hotSiteUrl = document.getElementById('hotSiteUrl').value;
            }
            todosFiltros += `&empresa=${hotSiteEmpresaID}&hotSiteUrl=${hotSiteUrl}`;

            let conteudoVagas = '';

            const request = await fetch(URL_API + 'vagas/buscar-novo?' + todosFiltros.replace('?', '&'));
            const response = await request.json();
            const retornoDados = response.model;

            if(boxCarregarMaisVagas)
                botaoCarregarMaisVagas.dataset.status = "pausado";

            
            if (carregarListaDeVagas) {
                if (response.sucesso && retornoDados.dados != undefined && retornoDados.dados.length > 0) {

                    this.removerCardsCarregamento(containerVagas);

                    document.getElementById('DivNectar')?.classList.add('d-md-block');
                    document.querySelector('.container-vagas .row').style.marginBottom = '0px';
                    document.querySelector('.container-vagas .row').classList.add('justify-content-center');

                    const termoBuscaVagaTexto = document.getElementById('TermoBuscaVagaTexto');
                    if (termoBuscaVagaTexto) 
                        termoBuscaVagaTexto.style.visibility = 'visible';
                    
                    if (retornoDados.pagina > 1 && !vagas.props.hotsiteEmployerPage) {
                        conteudoVagas += this.templates.textoIndicadorPagina(retornoDados.pagina, retornoDados.totalPaginas);
                    }

                    boxQuantidadeTotalVagas.forEach(el => {
                        el.style.display = 'block';
                    });

                    quantidadeTotalVagas.forEach(el => el.innerHTML = i18next.t('ListagemVagasQuantidade', { totalVagas: retornoDados.totalVagas, totalRegistro: retornoDados.totalRegistro }));

                    const inputShowAds = document.querySelector('#hotSiteShowAds') ? document.querySelector('#hotSiteShowAds').value : null;

                    for (let i = 0; i < retornoDados.dados.length; ++i) {
                        conteudoVagas += vagas.props.hotsiteEmployerPage ?  this.templates.cardVagaEmployerPage(retornoDados.dados[i]) : this.templates.cardVaga(retornoDados.dados[i]);
                    }

                    containerVagas.innerHTML += conteudoVagas;
                }
                else {
                    boxQuantidadeTotalVagas.forEach(el => {
                        el.style.display = 'none';
                    });

                    containerVagas.innerHTML = '';
                    quantidadeTotalVagas.forEach(el => el.innerHTML = i18next.t('ListagemVagasQuantidade', { totalVagas: 0, totalRegistro: 0 }));
                    conteudoVagas = this.templates.alertaNenhumaVaga();
                    document.getElementById('DivNectar') ? document.getElementById('DivNectar')?.classList.remove('d-md-block') : '';
                    document.querySelector('.container-vagas .row').style.marginBottom = '200px';
                    document.querySelector('.container-vagas .row').classList.add('justify-content-center');

                    const termoBuscaVagaTexto = document.getElementById('TermoBuscaVagaTexto');
                    if (termoBuscaVagaTexto) 
                        termoBuscaVagaTexto.style.visibility = 'hidden';

                    containerVagas.innerHTML += conteudoVagas;
                    document.getElementById('limparFiltros').addEventListener('click', async (e) => {
                        await vagas.eventoClickBotaoFiltros(e, e.target, true);
                    });
                }
            }

            this.montarFiltros(retornoDados.facets, carregarListaDeVagas);
            
            this.preencherCheckboxRadioFiltrosPelaURL(acionadoPeloPopstate);
            
            this.atualizarTextoQuantidadeGlobalFiltrosSelecionados();

            if (this.props.paginaAtual >= retornoDados.totalPaginas) {
                boxCarregarMaisVagas.style.display = 'none';
            }
            else {
                boxCarregarMaisVagas.style.display = 'flex';
            }

            //Esta realmente visivel o botao, troca status para pronto - onde o observer vai agir
            if (boxCarregarMaisVagas.style.display == 'flex') {
                botaoCarregarMaisVagas.dataset.status = "pronto";
                this.scrollInfinitoObterMaisVagas();
            }

            quicklinkListen({
                ignores: [
                    (uri, elem) => !elem.hasAttribute('prefetch') //Os links que possuiram tal atributo irão dar prefetch
                ]
            });

            if (this.props.paginaAtual === 1) {
                let buscaCompleta = true;
                if (!isNullOrEmpty(this.props.queryUrlAmigavel.query)) {
                    //addTrack('Busca Vagas', { cargo: this.props.queryUrlAmigavel.query.toLowerCase() });

                } else {
                    buscaCompleta = false;
                }
                if (!isNullOrEmpty(this.props.queryUrlAmigavel.localidade)) {
                    //addTrack('Busca Vagas', { localidade: this.props.queryUrlAmigavel.localidade.toLowerCase() });
                } else {
                    buscaCompleta = false;
                }
                if (buscaCompleta) {
                    //addTrack('Busca Vagas', { cargo: this.props.queryUrlAmigavel.query.toLowerCase(), localidade: this.props.queryUrlAmigavel.localidade.toLowerCase() });
                }
            }

            // comentado pois alerta de vagas na busca de vagas nao sera implementado nesse estagio
            // descomentar para ativar 
            // if (retornoDados.cargoValido) {
            //     const wrapperAlertaVagaLista = document.getElementsByClassName('wrapper-alerta-vaga');

            //     if (!wrapperAlertaVagaLista)
            //         return;

            //     for (const wrapperAlertaVaga of wrapperAlertaVagaLista) {                    
            //         wrapperAlertaVaga.classList.remove('d-none');
            //         wrapperAlertaVaga.querySelector('.cargo-alerta-vaga').textContent = this.props.queryUrlAmigavel.query;
                    
            //         const botao = wrapperAlertaVaga.querySelector('.botao-alerta-vaga-busca');
    
            //         if (!botao)
            //             continue;
    
            //         botao.setAttribute('data-cargo', this.props.queryUrlAmigavel.query);
            //         if (this.props.queryUrlAmigavel.localidade != '')
            //             botao.setAttribute('data-localidade', this.props.queryUrlAmigavel.localidade);
    
            //         new AlertaVaga(botao);
            //     }

            // }

            return retornoDados;
        }
        catch (e) {
            console.error({ catchObterVagas: e });
            containerVagas.innerHTML = this.templates.alertaNenhumaVaga();
            boxCarregarMaisVagas.style.display = 'none';
            botaoCarregarMaisVagas.dataset.status = "pausado";
        }

    },
    verificarURLFiltros() {
        //Tem parametros de filtro na url
        const urlParametros = obterQueryString().getAll;
        let queryString = '';

        if (Object.keys(urlParametros).length > 0) {
            //Se não tiver a query string explicita de query, pegar do SEO -> vagas-de-{query}
            if (urlParametros['query'] == undefined || urlParametros['query'] == null || urlParametros['query'].length == 0) {
                queryString += '&query=' + this.props.queryUrlAmigavel.query;
            }

            if (urlParametros['localidade'] == undefined || urlParametros['localidade'] == null || urlParametros['localidade'].length == 0) {
                queryString += '&localidade=' + this.props.queryUrlAmigavel.localidade;
            }

            for (let filtroNome in urlParametros) {
                urlParametros[filtroNome].forEach(valor => {
                    queryString += `&${filtroNome}=${valor}`;
                });
            }
        } else {

            //Se a URL vagas-de-{query}-em-{localidade} tiver os parametros diferente de queryUrlAmigavel, usar da URL
            let pathname = location.pathname.replace('/', '').replace(CULTURE_EMPREGARE, '').replace('/', '');
            let queryURLAmigavel = this.props.queryUrlAmigavel.query;
            let localidadeURLAmigavel = this.props.queryUrlAmigavel.localidade;

            if (pathname.includes('vagas-de-') && !pathname.includes('-em-')) {
                //vagas-de-auxiliar-administrativo
                pathname = pathname.replace('vagas-de-', '');

                //No caso de trabalho remoto, usa o prefixo -de-, mas vem query em branco do backend, entao preenche localidade
                //vagas-de-trabalho-remoto
                if (isNullOrEmpty(this.props.queryUrlAmigavel.query)) {
                    localidadeURLAmigavel = pathname.split('-').join(' ');
                } else {
                    queryURLAmigavel = pathname.split('-').join(' ');
                }

            } else if (pathname.includes('-em-') && !pathname.includes('vagas-de-')) {
                //vagas-em-sao-paulo
                localidadeURLAmigavel = pathname.split('-em-').splice(1).join().split('-'); //ignora algo anterior a -em- e depois da split pelo `-`
                localidadeURLAmigavel = localidadeURLAmigavel.join(' ');
            } else if (pathname.includes('vagas-de-') && pathname.includes('-em-')) {
                //vagas-de-auxiliar-administrativo-em-sao-paulo
                pathname = pathname.replace('vagas-de-', '');
                const pathnameSplit = pathname.split('-em-');
                queryURLAmigavel = pathnameSplit[0].replace(/-/g, ' ');
                localidadeURLAmigavel = pathnameSplit[1].replace(/-/g, ' ');
            } else if (pathname.includes('vagas') && location.search.length == 0) {
                //Verifica se a url está totalmente sem query amigavel e sem query string, resetando variaveis em memoria para o evento popstate
                this.props.queryUrlAmigavel.query = this.props.queryUrlAmigavel.localidade = '';
                this.atualizarListaFiltrosSelecionados([{ nome: 'query', valor: this.props.queryUrlAmigavel.query }], false);
                this.atualizarListaFiltrosSelecionados([{ nome: 'localidade', valor: this.props.queryUrlAmigavel.localidade }], false);
            }

            if (queryURLAmigavel != this.props.queryUrlAmigavel.query) {
                queryURLAmigavel = this.props.queryUrlAmigavel.query;
            }

            if (localidadeURLAmigavel != this.props.queryUrlAmigavel.localidade) {
                localidadeURLAmigavel = this.props.queryUrlAmigavel.localidade;
            }

            queryString += '&query=' + queryURLAmigavel;
            queryString += '&localidade=' + localidadeURLAmigavel;
        }
        return queryString;
    },
    limparFormatacaoDropdownSelecionado(urlParametros) {
        this.props.filtrosSelecionados.forEach(filtro => {
            if (!urlParametros.includes(filtro.nome)) {
                document.querySelectorAll('.dropdown-' + filtro.nome).forEach(el => {
                    el.classList.remove('btn-secondary');
                    if (el.querySelector('.quantidade-' + filtro.nome + '-filtro') != undefined) {
                        el.querySelector('.quantidade-' + filtro.nome + '-filtro').innerHTML = '';
                    }
                });
            }
        });
    },
    preencherCheckboxRadioFiltrosPelaURL(popstate = false) {
        let urlParametros = obterQueryString().getAll;

        if (popstate) {
            //Caso nao tenha mais o filtro selecionado limpa o dropdown selecionado
            this.limparFormatacaoDropdownSelecionado(urlParametros);
        }

        for (let filtroNome in urlParametros) {
            urlParametros[filtroNome].forEach(valor => {
                document.querySelectorAll('input[name="' + filtroNome + '"]:not([type="text"])').forEach(el => {
                    if (el.value == valor) {
                        el.checked = true;
                        this.manipularFiltrosSelecionados(el);
                        this.manipularDropdownFiltroSelecionado(filtroNome);
                    }
                });
            });
        }

    },
    async eventoSubmitFormHeaderBuscarVagas(form) {
        const { eventoBuscarVagaRedirect } = await import('./utilidades/eventoBuscarVagaRedirect');
        form.removeEventListener('submit', eventoBuscarVagaRedirect);
        form.addEventListener('submit', async (e) => {

            e.preventDefault();
            this.props.paginaAtual = 1;
            window.scrollTo(0, 0);
            const inputCargo = e.target.querySelector('input[name="cargo"]').value;
            const inputLocalizacao = e.target.querySelector('input[name="localizacao"]').value;
            await this.atualizarListaFiltrosSelecionados([
                { nome: 'query', valor: inputCargo },
                { nome: 'localidade', valor: inputLocalizacao }
            ]);
        });
    },
    async eventoClickBotaoFiltros(e, botao, acaoEliminarFiltros) {
        e.preventDefault();
        this.props.paginaAtual = 1;

        if (acaoEliminarFiltros) {
            await this.acaoEliminarFiltroEspecifico(botao.dataset.filtro);
            this.mudarTermoBuscaVagaTexto(this.props.queryUrlAmigavel.query, this.props.queryUrlAmigavel.localidade);
        }
        else {
            await this.acaoAplicarFiltroEspecifico(botao.dataset.filtro);
        }

        this.trocarSetaDropdown(e.target);

        let offcanvasFiltros = bootstrap.Offcanvas.getInstance('.offcanvas-filtro-vagas');
        if (offcanvasFiltros != null) {
            offcanvasFiltros.hide();
        }
    },
    trocarSetaDropdown(elemento) {
        if (elemento.closest('.dropdown') != undefined) {
            elemento.closest('.dropdown').dispatchEvent(new Event('hide.bs.dropdown'));
            elemento.closest('.dropdown-menu').classList.toggle('show');
        }
    },
    scrollInfinitoObterMaisVagas() {
        //Observa o botão de carregar mais vagas
        if(!vagas.props.hotsiteEmployerPage)
            this.props.observerCarregarMaisVagas.observe(document.querySelector('.btn-carregar-mais-vagas'));
    },
    async init() {
        const { autocompleteBuscaRecenteCargo, autocompleteBuscaRecenteLocalizacao } = await import('./utilidades/eventoBuscarVagaRedirect');

        const temParametrosNaUrl = (location.search.length > 0);

        banner.renderizar('banner-busca-vagas', localBanner.VAGA_BUSCA, false)
        banner.renderizar('banner-busca-vagas-mobile', localBanner.VAGA_BUSCA)

        if (!isNullOrEmpty(obterQueryString()['query']) || !isNullOrEmpty(this.props.queryUrlAmigavel.query)) {
            await this.atualizarListaFiltrosSelecionados([{ nome: 'query', valor: (obterQueryString()['query'] || this.props.queryUrlAmigavel.query) }], false);
        }

        if (!isNullOrEmpty(obterQueryString()['localidade'])) {
            await this.atualizarListaFiltrosSelecionados([{ nome: 'localidade', valor: (obterQueryString()['localidade'] || this.props.queryUrlAmigavel.localidade) }], false);
        }

        window.addEventListener('adicionarCustomFiltro', (e) => {
            this.atualizarListaFiltrosSelecionados(e.detail, false);
        });

        window.addEventListener('popstate', async (e) => {

            await this.obterVagas(true, true);
        });

        await this.obterVagas(temParametrosNaUrl, false, temParametrosNaUrl);

        const btnCarregarMaisVagas = document.querySelector('.btn-carregar-mais-vagas');

        btnCarregarMaisVagas.addEventListener('click', async (e) => {
            //Se o JS estiver habilitado, o comportamento padrão do link não vai funcionar (redirecionar), carregando as vagas por JS
            //Vai ser usado apenas por bots
            e.preventDefault();
            ++this.props.paginaAtual;
            await this.obterVagas(false, false);
        });

        //Remove evento redirect, pois na vaga só precisa chamar o metodo de listagem sem a necessidade de redirect        
        document.querySelectorAll('.formHeaderBuscarVagas').forEach(el => {
            this.eventoSubmitFormHeaderBuscarVagas(el);
        });

        document.querySelectorAll('.btn-eliminar-filtros').forEach(el => el.addEventListener('click', async (e) => {
            await this.eventoClickBotaoFiltros(e, el, true);
        }));

        document.querySelectorAll('.btn-aplicar-filtros').forEach(el => el.addEventListener('click', async (e) => {
            await this.eventoClickBotaoFiltros(e, el, false);
        }));

        //Botão de fechar o dropdown menu
        document.querySelectorAll('.btn-fechar-dropdown').forEach(el => el.addEventListener('click', (e) => {
            this.trocarSetaDropdown(e.target);
        }));

        function alertaHotsiteSemVagas() {
            const usuario = getUsuarioLogado();
            const textoNenhumaVaga = document.getElementById('textoNenhumaVaga');
            const btnNenhumaVaga = document.getElementById('btnNenhumaVaga');

            if (textoNenhumaVaga && btnNenhumaVaga) {
                if (usuario && usuario.logado) {
                    textoNenhumaVaga.innerHTML = `${i18next.t('TemplateAlertaNenhumaVagaLogado')}`;
                    btnNenhumaVaga.innerHTML = `${i18next.t('TemplateAlertaNenhumaVagaRevisarCurriculo')}`;
                    btnNenhumaVaga.href = `/${CULTURE_EMPREGARE}/candidato/curriculo`;
                } else {
                    textoNenhumaVaga.innerHTML = `${i18next.t('TemplateAlertaNenhumaVagaNaoLogado')}`;
                    btnNenhumaVaga.innerHTML = `${i18next.t('TemplateAlertaNenhumaVagaCadastrarCurriculo')}`
                    btnNenhumaVaga.href = `/${CULTURE_EMPREGARE}/cadastrar-curriculo`;
                }
            }
        }
        alertaHotsiteSemVagas();
        window.addEventListener('LoginHotsite', alertaHotsiteSemVagas);

        //Autocompletes para o offcanvas
        autocompleteBuscaRecenteLocalizacao(null, '#filtro-localizacao');
        autocompleteBuscaRecenteCargo(document.querySelector('.offcanvas-filtro-vagas'), '#filtro-cargo');

        window.addEventListener('beforeunload', () => {
            window.scrollTo(0, 0);
        });

        this.scrollInfinitoObterMaisVagas();
    }
};
// await vagas.init();
// })


(async () => await vagas.init())();